import { assetActionTypes } from '../../config/constant'
import { Asset, EmptyBlueAsset } from '../reducers/assets'

const updateSelectedAsset = (updateAssetObject: Partial<Asset>) => {
    return {
        type: assetActionTypes.UPDATE_ASSET_SELECTION,
        payload: {
            blueSelectedAsset: updateAssetObject,
        },
    }
}

const resetSelectedAsset = () => {
    return {
        type: assetActionTypes.RESET_ASSET_SELECTION,
        payload: {
            blueSelectedAsset: EmptyBlueAsset,
        },
    }
}

const updateSelectedDetection = (updateDetectionObject: Asset) => {
    return {
        type: assetActionTypes.UPDATE_DETECTION_SELECTION,
        payload: {
            detectedSelectedAsset: updateDetectionObject,
        },
    }
}

const resetSelectedDetection = () => {
    return {
        type: assetActionTypes.UPDATE_DETECTION_SELECTION,
        payload: {
            detectedSelectedAsset: {
                name: '',
                latitude: '-',
                longitude: '-',
                velocity: '-',
                altitude: '-',
                tilt: '-',
                pitch: '-',
                payload: '-',
            },
        },
    }
}

const updateDetectionList = (detectionList: Partial<Asset>[]) => {
    return {
        type: assetActionTypes.UPDATE_DETECTION_LIST,
        payload: {
            detectedList: detectionList,
        },
    }
}

const clearDetectionList = () => {
    return {
        type: assetActionTypes.CLEAR_DETECTION_LIST,
        payload: {
            detectedList: null,
        },
    }
}

export default {
    updateSelectedAsset,
    resetSelectedAsset,
    updateSelectedDetection,
    resetSelectedDetection,
    updateDetectionList,
    clearDetectionList,
}
